import React from 'react';
import { Box, Typography} from '@mui/material';

const WhatsAppContact = ({ imageSrc, title, message, phoneNumber }) => {
  

  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{
        border: '1px solid #ccc',
        borderRadius: '8px',
        p: 2,
        maxWidth: '400px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Box
        component="img"
        src={imageSrc}
        alt="logo da impresa"
        sx={{
          width: '140px',
          height: '80px',
          marginRight: 2,
    
        }}
      />
      <Box>
        <Typography variant="h6">{title}</Typography>
        <Typography
          sx={{
            mt: 1,
            display: 'inline-block',
            color: 'green',
            fontSize: '0.9rem'
          }}
        >
          {phoneNumber}
        </Typography>
      </Box>
    </Box>
  );
};

export default WhatsAppContact;
